import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {VideoComponent} from './video/video.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {ClearComponent, PermissionsComponent} from './permissions/permissions.component';
import {FineComponent} from './fine/fine.component';


const routes: Routes = [
    {
        path: 'video/:slug',
        component: VideoComponent
    },
    {
        path: 'video/:slug/:theme',
        component: VideoComponent
    }, {
        path: 'permissions',
        component: PermissionsComponent
    }, {
        path: 'not-found',
        component: NotFoundComponent
    }, {
        path: 'fine',
        component: FineComponent
    }, {
        path: 'clear',
        component: ClearComponent
    }, {
        path: '',
        redirectTo: 'not-found',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
